import { joinUrl } from "@balabalabom/ui";

/** Homepage on apex/www always goes here. Other paths stay on this host. */
export const SHOP_HOME_URL = "https://store.balabalabom.com";

const DEFAULT_STORE = SHOP_HOME_URL;

/** Apex / www still serve client-public; send `/` only to Shop. Kids host keeps stories home. */
const BRAND_HOME_HOSTS = new Set(["www.balabalabom.com", "balabalabom.com"]);

export const KIDS_HOST = "kids.balabalabom.com";

function currentHostname(): string {
  if (typeof window === "undefined") return "";
  return window.location.hostname;
}

export function isKidsHost(hostname: string): boolean {
  return hostname.trim().toLowerCase() === KIDS_HOST;
}

/**
 * Store app origin (`REACT_APP_STORE_URL`).
 * Set to empty string to hide store entry points.
 * `kids.balabalabom.com` never links or redirects to Shop.
 */
export function getStoreBaseUrl(hostname = currentHostname()): string | null {
  if (isKidsHost(hostname)) return null;
  const raw = process.env.REACT_APP_STORE_URL;
  if (raw === "") return null;
  const v = (raw ?? DEFAULT_STORE).trim();
  if (!v) return null;
  return v.replace(/\/+$/, "");
}

export function getStorePathUrl(
  path: string,
  hostname = currentHostname()
): string | null {
  const base = getStoreBaseUrl(hostname);
  if (!base) return null;
  if (!path || path === "/") return base;
  return joinUrl(base, path);
}

export function isBrandHomeHost(hostname: string): boolean {
  return BRAND_HOME_HOSTS.has(hostname.trim().toLowerCase());
}

/** www / apex `/` should open Shop; `kids.balabalabom.com` and local/preview stay on kids home. */
export function shouldRedirectHomeToStore(
  hostname = currentHostname()
): boolean {
  return isBrandHomeHost(hostname);
}
